import React, { useCallback, useEffect, useState } from "react";
import { Card, Pagination, Button, ConfigProvider, Input,message } from "antd";
import { useHistory } from "react-router-dom";
import "./index.scss";
import JobItem from "./JobItem";
import Http from "../../../../networkReq/http";
import Request from "../../../../networkReq/request";
import zh_CN from "antd/es/locale/zh_CN";

const { Search } = Input;

const jobData = [
  {
    job: "xxx1111111职位",
    placeOfWorkType: "眉山市 东坡区",
    auditMechanismName: "xxx公司",
    resumeOrNot: true,
    recruitsNumber: 100,
    salary: "13-17k",
    workExperience: "3-5",
    degree: "本科",
    type: "私营企业",
    auditMechanismScale: "100-499",
    welfare: "通讯补贴，员工旅游，五险一金，定期体检，",
    favoriteOrNot: true,
  }, 
  {
    job: "xxx职位",
    placeOfWorkType: "眉山市 东坡区",
    auditMechanismName: "xxx公司",
    resumeOrNot: true,
    recruitsNumber: 100,
    salary: "13-17k",
    workExperience: "3-5",
    degree: "本科",
    type: "私营企业",
    auditMechanismScale: "100-499",
    welfare: "通讯补贴，员工旅游，五险一金，定期体检，",
    favoriteOrNot: true,
  },
];

function itemRender(current, type, originalElement) {
  if (type === "prev") {
    return <a>上一页</a>;
  }
  if (type === "next") {
    return <a>下一页</a>;
  }
  return originalElement;
}

export default function JobCollection(props) {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); //当前页数
  const [total, setTotal] = useState(0);
  const [searchValue, setSearchValue] = useState(""); //搜索框value值
  const [succeed, setSucceed] = useState(0); //收藏
  const [succeedTwo, setSucceedTwo] = useState(0); //收藏
  const handlePage = useCallback((page, pageSize) => {
    setCurrentPage(page);
  }, []);

  const history = useHistory();
  const handleJobDetail = useCallback((id) => {
    history.push(`/entrance/personal/jobCollection/detail/${id}`);
  }, []);

  const collect = useCallback((id, collectValue) => {
    //收藏方法和取消收藏方法
    console.log("collectcollect", collect);
    if (collectValue == 0) {
      Http.get(Request.collectList(), { id: id }, (obj) => {
        if (obj.code == 200) {
          setSucceed(id);
          setSucceedTwo(collectValue);
          message.success("收藏成功", 2);
        }
      });
    } else {
      Http.get(Request.cancelCollectList(), { id: id }, (obj) => {
        if (obj.code == 200) {
          setSucceed(id);
          setSucceedTwo(collectValue);
          message.success("取消成功", 2);
        }
      });
    }
  }, []);
  //改变searchValue
  const handleChangeSearchValue = useCallback((e) => {
    setSearchValue(e.target.value);
  }, []);
  useEffect(()=>{
    handleSearch()
  },[])
  //搜索函数
  const handleSearch = (params) => {
    //调用dispatch   获取后端数据
    console.log('paramsparamsparamsparams',params);
    
    Http.get(Request.getJobCollect(), { current:currentPage,size:10,...params }, (obj) => {
      // console.log('objobjobjobjobj',obj);
      
      setData(obj.data?.records || []);
      setTotal(obj.data?.total || []);
    });
  };

  const searchInput = useCallback((params)=>{
    handleSearch({text:params})
  },[searchValue])
  useEffect(() => {
    handleSearch()
    // setData(jobData);
    // setTotal(500);
  }, [currentPage,succeed,succeed]);

  return (
    <div className="job_collection">
      <div style={{ padding: "16px 24px", background: "#fff" }}>
        <Search
          placeholder="请输入关键词搜索"
          onChange={handleChangeSearchValue}
          style={{ width: "100%" }}
          value={searchValue}
          onSearch={searchInput}
        />
      </div>
      {data.map((item, index) => {
        return (
          <JobItem job={item} key={index} collect={collect} handleJobDetail={handleJobDetail} />
        );
      })}
      <ConfigProvider locale={zh_CN}>
        <Pagination
          total={total}
          itemRender={itemRender}
          showQuickJumper={{
            goButton: <Button className={"pagination_jump"}>确定</Button>,
          }}
          showTotal={(total) => `共 ${total} 条`}
          onChange={handlePage}
          showSizeChanger={false}
          current={currentPage}
          style={{
            marginTop: 14,
            paddingRight: 24,
            display: "flex",
            justifyContent: "flex-end",
          }}
        />
      </ConfigProvider>
    </div>
  );
}
